module.exports = __webpack_public_path__ + "img/duplicar.ce83473f.svg";